import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import AssetRequestManagementForm from './AssetRequestManagementForm'
import AssetRequestManagementTable from './AssetRequestManagementTable'
import { sessionRemoveItem, sessionSetItemObj } from '../../utils/sessionHelpers'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import { searchAssetRequestManagement } from '../../redux/actions/assetRequestManagement'
import notification from '../../utils/notification'
import { doneLoading, startLoading } from '../../utils/loading'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { getReserveDocumentRequest } from '../../redux/actions/assetRequestManagementDetail'
import { previewFile } from '../../utils/fileUtil'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function AssetRequestManagementWidgets(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props.schema.result || [])

  const history = useHistory()

  const onSearch = async (request, pagenumber = 1, pagesize = 5) => {
    console.log('onSearch', request)

    setIsLoading(true)
    startLoading()

    try {
      var response = await searchAssetRequestManagement(request, pagenumber, pagesize)
      console.log('response ', response.model)
      if (response.model) {
        setDataTable(response?.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSelecetAssetRequest = async (rowData) => {
    // console.log('handleSelecetAssetRequest ', rowData)

    if (rowData) {
      sessionSetItemObj('bookingInfo', rowData)
    } else {
      sessionRemoveItem('bookingInfo')
    }

    history.push({
      pathname: pathname.durableArticles.AssetRequestManagementDetail,
    })
  }

  const handleSearchAssetRequest = async (
    pagesize,
    pagenumber,
    requestForUseDocNo,
    projectCode,
    projectName,
    startDate,
    endDate,
    requestForUseStatus
  ) => {
    const request = {
      pagesize,
      pagenumber,
      requestForUseDocNo,
      projectCode,
      projectName,
      startDate,
      endDate,
      requestForUseStatus,
    }

    onSearch(request, pagenumber, pagesize)
  }

  const handleGetReserveDoc = async (rowData) => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await getReserveDocumentRequest(rowData.id)

      previewFile(file, `แบบฟอร์มขอใช้งานครุภัณฑ์โครงการ_${rowData.id}`)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={' '} bordered>
        <AssetRequestManagementTable
          schema={dataTable}
          searchForm={formSchema.searchForm}
          loading={isLoading}
          onSearch={onSearch}
          onSelect={handleSelecetAssetRequest}
          onReload={handleSearchAssetRequest}
          onPreview={handleGetReserveDoc}
        />
      </Panel>
    </>
  )
}
